import { createTheme } from "@mui/material/styles";

export const createDashboardTheme = (config) => {
  const {
    primaryColor = "#472ed1",
    secondaryColor = "#db3a3e",
    mode = "light",
    fontFamily = "Poppins",
    fontSize = 14,
    borderRadius = 16,
    spacing = 8,
    compactMode = false,
  } = config;

  return createTheme({
    palette: {
      mode,
      primary: {
        main: primaryColor,
      },
      secondary: {
        main: secondaryColor,
      },
      background: {
        default: mode === "dark" ? "#121212" : "#F9F9F9",
        paper: mode === "dark" ? "#1E1E1E" : "#FFFFFF",
      },
    },
    typography: {
      fontFamily,
      fontSize,
    },
    shape: {
      borderRadius,
    },
    spacing: compactMode ? spacing * 0.75 : spacing,
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius,
            fontSize,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: borderRadius * 1.5,
          },
        },
      },
    },
  });
};
